import { useConvexAuth } from "convex/react";
import { useAuthActions } from "@convex-dev/auth/react";
import { useQuery } from "convex/react";
import { api } from "../../convex/_generated/api";
import { useEffect } from "react";

const EMAIL_KEY = "jbb_portal_email";

function getStoredEmail() {
  return localStorage.getItem(EMAIL_KEY) ?? "";
}

export function useAuth() {
  const { isAuthenticated, isLoading } = useConvexAuth();
  const { signOut } = useAuthActions();
  const user = useQuery(api.auth.getCurrentUser, isAuthenticated ? {} : "skip");

  useEffect(() => {
    if (user?.email) localStorage.setItem(EMAIL_KEY, user.email);
    if (!isAuthenticated && !isLoading) localStorage.removeItem(EMAIL_KEY);
  }, [isAuthenticated, isLoading, user?.email]);

  return {
    email: user?.email ?? getStoredEmail(),
    isAdmin: user?.isAdmin ?? false,
    isAuthenticated,
    isLoading: isLoading || (isAuthenticated && user === undefined),
    role: user?.role ?? null,
    temporaryPassword: user?.temporaryPassword ?? false,
    user,
    logout: signOut,
  };
}
